import { useForm } from '@refinedev/antd';
import { Create } from '@refinedev/antd';
import { Form, Input, InputNumber, Select, DatePicker, Switch, Card, Row, Col } from 'antd';
import { LabelWithHelp, SectionTitle } from '../../components/ui/HelpTooltip';
import { t } from '../../i18n';

export const PromoCodeCreate = () => {
  const { formProps, saveButtonProps } = useForm({
    resource: 'admin/promo-codes',
    redirect: 'list',
  });

  return (
    <Create saveButtonProps={saveButtonProps} title={t('promo.newPromo')}>
      <Form {...formProps} layout="vertical">
        <Row gutter={24}>
          <Col xs={24} lg={12}>
            <Card
              title={
                <SectionTitle
                  title={t('staff.basicInfo')}
                  help="Promo kodning asosiy sozlamalari - kod, turi va qiymati"
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('promo.code')}
                    help="Foydalanuvchilar kiritadigan kod. Katta harflarda saqlanadi."
                  />
                }
                name="code"
                rules={[
                  { required: true, message: 'Promo kodni kiriting' },
                  { min: 3, message: "Kamida 3 ta belgi bo'lishi kerak" },
                ]}
              >
                <Input
                  placeholder="SAFARGO2024"
                  style={{ textTransform: 'uppercase' }}
                />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('promo.type')}
                    help="FOIZ - sayohat narxidan foiz chegirma. QAT'IY SUMMA - aniq summa chegirma."
                  />
                }
                name="type"
                rules={[{ required: true, message: 'Turini tanlang' }]}
                initialValue="PERCENTAGE"
              >
                <Select
                  placeholder="Chegirma turini tanlang"
                  options={[
                    { value: 'PERCENTAGE', label: 'Foiz (%)' },
                    { value: 'FIXED_AMOUNT', label: "Qat'iy summa (so'm)" },
                  ]}
                />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('promo.value')}
                    help="Foiz uchun: 10 = 10% chegirma. Summa uchun: 10000 = 10,000 so'm chegirma."
                  />
                }
                name="value"
                rules={[{ required: true, message: 'Qiymatni kiriting' }]}
              >
                <InputNumber
                  min={1}
                  style={{ width: '100%' }}
                  placeholder="10"
                />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('common.active')}
                    help="Promo kod ishlaydimi yoki yo'qmi"
                  />
                }
                name="isActive"
                valuePropName="checked"
                initialValue={true}
              >
                <Switch checkedChildren="Ha" unCheckedChildren="Yo'q" />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card
              title={
                <SectionTitle
                  title={t('promo.title')}
                  help="Promo koddan foydalanish cheklovlari"
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('promo.maxUsages')}
                    help="Promo kod umumiy necha marta ishlatilishi mumkin. Bo'sh = cheklanmagan."
                  />
                }
                name="maxUsages"
              >
                <InputNumber
                  min={1}
                  style={{ width: '100%' }}
                  placeholder="100"
                />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('promo.minTripAmount')}
                    help="Promo kod ishlashi uchun sayohat narxi qancha bo'lishi kerak"
                  />
                }
                name="minTripAmount"
              >
                <InputNumber
                  min={0}
                  style={{ width: '100%' }}
                  placeholder="50000"
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                  }
                  parser={(value) => Number(value?.replace(/\s/g, '') || 0)}
                />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label={t('promo.maxDiscount')}
                    help="Foizli chegirma uchun maksimal summa. Masalan: 20% chegirma lekin maksimum 50,000 so'm."
                  />
                }
                name="maxDiscount"
              >
                <InputNumber
                  min={0}
                  style={{ width: '100%' }}
                  placeholder="50000"
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                  }
                  parser={(value) => Number(value?.replace(/\s/g, '') || 0)}
                />
              </Form.Item>
            </Card>

            <Card
              title={
                <SectionTitle
                  title={t('promo.validity')}
                  help="Promo kod qaysi sanadan qaysi sanagacha ishlaydi"
                />
              }
              style={{ marginTop: 24 }}
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label={t('promo.startDate')}
                        help="Promo kod qaysi sanadan boshlab ishlaydi. Bo'sh = hozirdan."
                      />
                    }
                    name="startsAt"
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder="Sanani tanlang"
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label={
                      <LabelWithHelp
                        label={t('promo.endDate')}
                        help="Promo kod qaysi sanada tugaydi. Bo'sh = cheklanmagan."
                      />
                    }
                    name="expiresAt"
                  >
                    <DatePicker
                      style={{ width: '100%' }}
                      placeholder="Sanani tanlang"
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
